// In the admin app the version is exposed via wyA11yGlobals; in the
// front-end scanner dashboard (loaded on audit URLs) it's exposed via
// wya11yChecker. Fall back to both so this constant works in either
// context.
declare global {
  interface Window {
    wya11yChecker?: {
      version?: string;
      [key: string]: unknown;
    };
  }
}

export const PLUGIN_VERSION =
  window?.wyA11yGlobals?.version ?? window?.wya11yChecker?.version ?? "";
